import { Deserializer } from 'jsonapi-serializer';
const { deserialize } = new Deserializer({
  keyForAttribute: 'snake_case',
});

export default deserialize;